import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CardService } from './card.service';
@Component({
  selector: 'app-attention',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
  // variables
  data = [];
  userId = '';
  memberCardTemplate: MemberCardTemplate = new MemberCardTemplate();
  logo: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cardService: CardService
  ) {}

  ngOnInit() {
    this.userId = this.route.snapshot.queryParamMap.get('UserId');
    if (this.userId === '') {
    } else {
      this.router.navigate(['card']);
    }
    this.getMemberCardTemplate();
  }

  // Get all card details API
  getMemberCardTemplate() {
    this.cardService.getMemberCardTemplate(this.userId).subscribe(res => {
      this.memberCardTemplate.clientLogo = res.clientLogo;
      this.memberCardTemplate.programName = res.programName;
      this.memberCardTemplate.clientName = res.clientName;
      this.memberCardTemplate.idNumber = res.idNumber;
      this.memberCardTemplate.memberFirstName = res.memberFirstName;
      this.memberCardTemplate.memberLastName = res.memberLastName;
      this.memberCardTemplate.rxGroup = res.rxGroup;
      this.memberCardTemplate.rxbin = res.rxbin;
      this.memberCardTemplate.pcnNumber = res.pcnNumber;
      this.memberCardTemplate.memberCode = res.memberCode;
      this.memberCardTemplate.pharmacyHelpDeskNumber =
        res.pharmacyHelpDeskNumber;
      this.memberCardTemplate.companyLogo = res.companyLogo;
      this.data = res;
      if (
        this.memberCardTemplate.clientLogo === '' ||
        this.memberCardTemplate.clientLogo === null
      ) {
        this.logo = true;
      } else {
        this.logo = false;
      }
      this.memberCardTemplate.pharmacyHelpDeskNumber =
        this.formatPharmacyHelpDeskNumber(
          this.memberCardTemplate.pharmacyHelpDeskNumber
        );
    });
  }

  private formatPharmacyHelpDeskNumber(value: string): string {
    if (!value) {
      return '';
    }

    const firstSeparator = value.length > 4
      ? `${value.slice(0, 4)}-${value.slice(4)}`
      : value;

    return firstSeparator.length > 8
      ? `${firstSeparator.slice(0, 8)}-${firstSeparator.slice(8)}`
      : firstSeparator;
  }
}

// Membercard DTO
export class MemberCardTemplate {
  clientId: number;
  memberId: number;
  clientName: string;
  idNumber: string;
  memberFirstName: string;
  memberLastName: string;
  rxGroup: string;
  rxbin: string;
  pcnNumber: string;
  memberCode: string;
  pharmacyHelpDeskNumber: string;
  memberEmail: string;
  memberContactNumber: string;
  programName: string;
  clientLogo: string;
  companyLogo: string;
}
